var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import moment from 'moment';
export function isNullOrWhiteSpace(value) {
    const ss = typeof value === 'number' ? value.toString() : value !== null && value !== void 0 ? value : '';
    // NULLまたは空白、スペース、タブのみの場合にtrueを返す
    return ss === null || ss.trim() === '';
}
export function getQueryParam(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export function tryJsonForObject(data) {
    try {
        return JSON.parse(JSON.stringify(data));
    }
    catch (_) {
        return data;
    }
}
export function getServerTime() {
    return __awaiter(this, void 0, void 0, function* () {
        // サーバー時間取得
        let response = null;
        try {
            response = yield axios
                .head(window.location.href)
                .then(res => {
                // console.log(`Get server time  TARGET >> ${window.location.href}  RESULT >> ${new Date(res.headers.date)}`);
                return new Date(res.headers.date);
            })
                .catch(e => {
                // console.log(e);
            });
        }
        catch (e) { }
        if (!response)
            return null;
        return moment(response).format('YYYY/MM/DD HH:mm:ss');
    });
}
export function isSuccessResponse(status) {
    return ![401, 403, 404, 408, 419, 422, 500].some(value => value === status);
}
export function isObjEmpty(obj) {
    return !Object.keys(obj).length;
}
